import { useState } from 'react';
import { default as FormattedMessage } from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { H4 } from 'foundations-components/transitional/components/H4';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import BusinessUnitSelect from 'ui-business-units-lib/components/BusinessUnitSelect';
import WithBusinessUnitsDataFetching from 'ui-business-units-lib/utils/WithBusinessUnitsDataFetching';
// @ts-expect-error Untyped import
import { useHideDialog } from '../../../dialog/ducks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BusinessUnitSelectWithData = WithBusinessUnitsDataFetching(BusinessUnitSelect);
const SetAssetBusinessUnitModal = ({
  AssetCountLabel,
  descriptionKey,
  initialValue,
  onSave
}) => {
  const closeDialog = useHideDialog();
  const [businessUnit, setBusinessUnit] = useState(initialValue);
  return /*#__PURE__*/_jsxs(Modal, {
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: closeDialog
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.setBusinessUnit.dialog.title_buv2"
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [AssetCountLabel && /*#__PURE__*/_jsx(H4, {
        children: AssetCountLabel
      }), /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.setBusinessUnit.dialog.prompt_buv2"
        }),
        help: /*#__PURE__*/_jsx(FormattedMessage, {
          message: descriptionKey
        }),
        children: /*#__PURE__*/_jsx(BusinessUnitSelectWithData, {
          buId: businessUnit,
          onChange: buId => {
            setBusinessUnit(buId);
          }
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: () => onSave(businessUnit),
        disabled: initialValue === businessUnit,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.setBusinessUnit.dialog.confirm_buv2"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "secondary",
        onClick: closeDialog,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.setBusinessUnit.dialog.reject"
        })
      })]
    })]
  });
};
export default SetAssetBusinessUnitModal;